// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Button$PrezzeeRibbon from "../../personal/Button/Button.bs.js";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var authButton = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.flexWrap("wrap"),
      BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.selector("button", [
                  BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(10)),
                  BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(18)),
                  BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(18)),
                  BsCssJs$PrezzeeRibbon.minWidth(BsCssJs$PrezzeeRibbon.px(125)),
                  BsCssJs$PrezzeeRibbon.whiteSpace("nowrap")
                ])]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [
            BsCssJs$PrezzeeRibbon.nthChild({
                  NAME: "add",
                  VAL: [
                    1,
                    2
                  ]
                }, [BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(12)))]),
            BsCssJs$PrezzeeRibbon.selector("button", [BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.pct(100))])
          ])
    ]);

var Styles = {
  authButton: authButton
};

function Auth__SignedOut(props) {
  return JsxRuntime.jsxs(React.Fragment, {
              children: [
                JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                      children: props.signUpButton,
                      variant: /* Small */1,
                      className: authButton
                    }),
                JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                      children: props.signInButton,
                      fill: /* Outlined */1,
                      colour: /* Secondary */6,
                      variant: /* Small */1,
                      className: authButton
                    })
              ]
            });
}

var make = Auth__SignedOut;

export {
  Styles ,
  make ,
}
/* authButton Not a pure module */
